<template>
	<slot :item="item" />
</template>

<script setup>
	const {getCartData} = useWebshop();
	const item = computed(() => getCartData()?.cart?.total_extra_shipping_to_free);
</script>
